import menu from './menu';
import signUp from './signUp';
import security from './security';
import solicitudEmpadronamiento from './solicitudEmpadronamiento';
import citaDeEmpadronamiento from './citaDeEmpadronamiento';
import solicitudEmpadronamientoExtranjero from './solicitudEmpadronamientoExtranjero';
import solicitudEmpadronamientoPortalWeb from './solicitudEmpadronamientoPortalWeb'
import fallecidos from './fallecidos';
import dialogoEstatus from './dialogoStatus';

const allActions = {
    security,menu, 
    signUp: signUp,
    solicitudEmpadronamiento:solicitudEmpadronamiento,
    citaDeEmpadronamiento: citaDeEmpadronamiento,
    solicitudEmpadronamientoExtranjero:solicitudEmpadronamientoExtranjero,
    solicitudEmpadronamientoPortalWeb:solicitudEmpadronamientoPortalWeb,
    fallecidos:fallecidos,
    solicitudDatosGenerado:solicitudEmpadronamientoExtranjero.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_GENERADO,
    idSolicitudDelegacionProcesado:solicitudEmpadronamientoExtranjero.ID_SOLICITUD_DELEGACION_PROCESADO,
    rangoNoBoletas: solicitudEmpadronamiento.RANGO_NO_BOLETAS,
    setTituloMenu: menu.SET_MENU_ITEM_TITLE,
    setCatalogoDiscapacidad: solicitudEmpadronamientoExtranjero.CATALOGO_DISCAPACIDAD,
    setCatalogoClasificacionDiscapacidad: solicitudEmpadronamientoExtranjero.CATALOGO_CLASIFICACION_DISCAPACIDAD,
    setResidenciaElectoralActualEnElPadron: solicitudEmpadronamientoPortalWeb.SET_RESIDENCIA_ACTUAL_PADRON,
    setDatosSolicitudExtranjero: solicitudEmpadronamientoExtranjero.DATOS_SOLICITUD_DELEGACION,
    setNumeroBoletaRenap: solicitudEmpadronamiento.GET_NUMERO_BOLETA_RENAP,
    dialogoEstatus: dialogoEstatus
};

export default allActions;
